<template>
    <div>
        <v-data-table :headers="headers" :items="desserts" :sort-desc="true" class="elevation-1 user-table"
            :search="search" loading-text="Carregando os dados..." no-data-text="Nenhum dado encontrado" :footer-props="{
                'items-per-page-text': 'Dados por página',
                'page-text': '{0}-{1} de {2}'
            }" mobile-breakpoint="600" :items-per-page="10">

            <template v-slot:top>
                <v-toolbar flat color="white" class="toolbar-custom">
                    <v-row align="center" justify="space-between" class="w-100">

                        <v-col cols="12" sm="4" class="d-flex align-center">
                            <v-chip v-if="$vuetify.breakpoint.mdAndUp" class="ma-2" color="primary" outlined pill>
                                <v-icon left>{{ icon }}</v-icon>
                                {{ title }}
                            </v-chip>
                        </v-col>

                        <!-- Campo de pesquisa centralizado -->
                        <v-col cols="12" sm="4" class="d-flex justify-center">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Pesquisar" single-line
                                hide-details outlined dense class="search-field" />
                            <v-btn v-if="localSearch" @click="initialize(localSearch)" color="green" elevation="2"
                                class="white--text">
                                <v-icon left>mdi-reload</v-icon>
                            </v-btn>
                        </v-col>

                        <slot name="acoes">
                            <!-- conteúdo padrão, caso nada seja passado -->
                            <v-col cols="12" sm="4" class="d-flex justify-end">
                                <!-- vazio por padrão -->
                            </v-col>
                        </slot>
                    </v-row>
                </v-toolbar>
            </template>



            <template v-slot:item.index="{ item }">
                <span>{{ desserts.indexOf(item) + 1 }}</span>
            </template>

            <!-- Status Column -->
            <template v-slot:item.status="{ item }">
                <v-chip :color="item.status == 1 ? 'warning' : 'success'" small dark>
                    {{ item.status == 1 ? 'Pendente' : 'Finalizado' }}
                </v-chip>
            </template>
            

             <!-- Coluna de Status_2 -->
            <template v-slot:item.situacao="{ item }">
                <v-chip small :color="item.status_2 == 1 ? 'green lighten-4' : 'red lighten-4'"
                    :text-color="item.status_2 == 1 ? 'green darken-2' : 'red darken-2'">
                    {{ item.status_2 == 1 ? 'Ativo' : 'Tracado/Anulado' }}
                </v-chip>
            </template>

            <!-- Coluna de Status -->
            <template v-slot:item.enable="{ item }">
                <v-chip small :color="item.enable == 1 ? 'green lighten-4' : 'red lighten-4'"
                    :text-color="item.enable == 1 ? 'green darken-2' : 'red darken-2'">
                    {{ item.enable == 1 ? 'Ativo' : 'Desativada' }}
                </v-chip>
            </template>

            <!-- Coluna de licencaExpirada -->
            <template v-slot:item.licencaExpirada="{ item }">
                <v-chip small :color="item.licencaExpirada == 1 ? 'green lighten-4' : 'red lighten-4'"
                    :text-color="item.licencaExpirada == 1 ? 'green darken-2' : 'red darken-2'">
                    {{ item.licencaExpirada == 1 ? 'Ativo' : 'Expirada' }}
                </v-chip>
            </template>

            <template v-slot:item.action="{ item }">
                <slot name="item-action" :item="item">
                    <!-- Fallback se o slot não for usado no pai -->
                    <v-menu offset-y left transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon v-bind="attrs" v-on="on" color="grey darken-1" class="action-btn">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item>
                                <v-list-item-title>Nenhuma ação</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </slot>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        headers: Array,
        desserts: Array,
        search: String,
        title: String,
        icon: String,
    },
    data() {
        return {
            localSearch: this.search || "",
        };
    },
    watch: {
        search(newVal) {
            this.localSearch = newVal;
        }
    },
    methods: {
        initialize(value) {
            this.$emit("search", value);
        },
    },
};
</script>

<style scoped>
.user-table {
    margin-top: 10px !important;
}

/* Estilos Gerais */
.toolbar-custom {
    border-radius: 8px 8px 0 0;
    padding: -5px 16px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.toolbar-content {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;
}

.search-container {
    flex: 1;
    min-width: 250px;
    max-width: 50%;
    display: flex;
    align-items: center;
}

.search-field {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    margin-right: 5px;
}

.status-indicators {
    display: flex;
    gap: 8px;
}

/* Efeito Zebra na Tabela */
.user-table>>>tbody tr:nth-of-type(odd) {
    background-color: #f8f9fa;
}

.user-table>>>tbody tr:hover {
    background-color: #e9f5ff !important;
    transform: scale(1);
    transition: all 0.2s ease;
}

.user-table>>>.v-data-table__mobile-table-row {
    background-color: white;
    margin-bottom: 8px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Avatar e Chips */
.user-avatar {
    border: 2px solid #e0e0e0;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.user-avatar:hover {
    transform: scale(1.1);
    border-color: #1976d2;
}

.v-chip {
    font-weight: 500;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Menu de Ações */
.action-menu {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.action-menu .v-list-item {
    min-height: 40px;
}

.action-menu .v-list-item:hover {
    background-color: #f5f5f5;
}

/* Responsividade - Tablet */
@media (max-width: 960px) {
    .toolbar-content {
        flex-direction: row;
        align-items: center;
    }

    .search-container {
        order: 2;
        width: 100%;
        margin: 8px 0;
    }

    .status-indicators {
        order: 3;
        justify-content: flex-end;
        width: 100%;
    }

    .user-table>>>th {
        font-size: 0.75rem;
    }

    .user-table>>>td {
        font-size: 0.875rem;
        padding: 8px 4px !important;
    }
}

/* Responsividade - Mobile */
@media (max-width: 600px) {
    .user-table {
        margin-top: 30px !important;
    }

    .toolbar-custom {
        padding: 8px 12px;
        border-radius: 0;
    }


    .toolbar-content {
        flex-direction: column;
        gap: 8px;
        margin-top: 60px;
    }

    .search-container {
        order: 1;
        margin: 4px 0;
    }

    .status-indicators {
        order: 2;
        justify-content: center;
        width: 100%;
    }

    .v-chip {
        font-size: 0.7rem;
        height: 24px;
    }

    .v-avatar {
        width: 20px !important;
        height: 20px !important;
    }

    /* Melhorias na tabela mobile */
    .user-table>>>.v-data-table__mobile-row {
        padding: 16px 12px;
        margin-bottom: 12px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        position: relative;
        overflow: hidden;
    }

    .user-table>>>.v-data-table__mobile-row::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
    }

    .user-table>>>.v-data-table__mobile-row__cell {
        padding: 6px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .user-table>>>.v-data-table__mobile-row__cell:before {
        content: attr(data-label);
        font-weight: 600;
        color: #555;
        margin-right: 16px;
        width: 100px;
        font-size: 0.8rem;
        flex-shrink: 0;
    }

    .user-table>>>.v-data-table__mobile-row__cell .v-chip {
        margin-left: auto;
    }

    /* Avatar mobile */
    .user-table>>>.v-data-table__mobile-row .user-avatar {
        width: 40px;
        height: 40px;
    }

    /* Menu de ações mobile */
    .action-menu {
        min-width: 180px;
    }

    .action-menu .v-list-item__title {
        font-size: 0.85rem;
    }
}

/* Ajustes para telas muito pequenas */
@media (max-width: 600px) {
    .search-field {
        font-size: 0.8rem;
    }

    .user-table>>>.v-data-table__mobile-row__cell:before {
        width: 80px;
        font-size: 0.75rem;
    }

    .user-table>>>.v-data-table__mobile-row__cell {
        font-size: 0.8rem;
    }

    .v-chip--outlined {
        padding: 0 6px;
    }

    .user-table>>>tbody tr:nth-of-type(odd) {
        background-color: #ececec;
    }
}

/* Animação suave para carregamento */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.user-table>>>tbody tr {
    animation: fadeIn 0.3s ease forwards;
}

.user-table>>>tbody tr:nth-child(1) {
    animation-delay: 0.1s;
}

.user-table>>>tbody tr:nth-child(2) {
    animation-delay: 0.2s;
}

.user-table>>>tbody tr:nth-child(3) {
    animation-delay: 0.3s;
}
</style>